import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import {
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '@cotera/client/v0/actions/framework';
import { Assert } from '@cotera/utilities';
import {
  DisplayError,
  ModalItem,
  ModalPageView,
  ShowSql,
} from '@cotera/client/app/components/app';
import { Suspense } from 'react';
import { Loading } from '@cotera/client/app/components/ui';
import { ErrorBoundary } from 'react-error-boundary';
import { DATASET_ACTION_GROUP } from './constants';
import { AskResponse } from '../../actions/framework/types';
import { DataGridModel } from '../../data-grid';

export class ViewSqlAction extends BaseAction<{}, { t: string }[]> {
  title = 'View SQL';
  description = 'View SQL';
  inputSchema = z.object({});
  group = DATASET_ACTION_GROUP;
  icon = 'code-bracket';

  constructor(
    private readonly modalManager: {
      push: (
        item: ModalItem & {
          onClose?: () => void;
        }
      ) => void;
    }
  ) {
    super();
  }

  applicable(context: ApplicableContext): boolean {
    const dataGrid = context.targetedModelOfType(DataGridModel);
    return dataGrid !== null;
  }

  async execute(_: z.infer<typeof this.inputSchema>, __: ExecuteContext) {
    //noop
    return ok({});
  }

  shouldAsk(_: ApplicableContext): boolean {
    return true;
  }

  ask(_: {}, context: ExecuteContext): AskResponse<{}> {
    const dataGrid = context.targetedModelOfType(DataGridModel);

    Assert.assert(dataGrid !== null, 'DataGrid model not found');

    const rel = dataGrid.baseRel;

    return {
      view: ({ onCancel }) => {
        this.modalManager.push({
          view: () => (
            <ModalPageView className="p-4 h-full">
              <ErrorBoundary
                fallbackRender={({ error }) => <DisplayError error={error} />}
              >
                <Suspense fallback={<Loading.Spinner />}>
                  <ShowSql rel={rel} className="h-full overflow-y-auto" />
                </Suspense>
              </ErrorBoundary>
            </ModalPageView>
          ),
          onClose: async () => {
            await onCancel();
          },
        });
      },
    };
  }
}
